import { render } from "./ViewUser.vue?vue&type=template&id=21f00353&scoped=true&ts=true"
import script from "./ViewUser.vue?vue&type=script&lang=ts"
export * from "./ViewUser.vue?vue&type=script&lang=ts"

import "./ViewUser.vue?vue&type=style&index=0&id=21f00353&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f00353"]])

export default __exports__